import Vue from 'vue';
import {PluginObject} from "vue/types/umd";
import AxiosAuthService from "@/services/AxiosAuthService";
import AxiosCompanyService from "@/services/AxiosCompanyService";
import AxiosUserService from "@/services/AxiosUserService";
import AxiosBillService from "@/services/AxiosBillService";
import AxiosOrderService from "@/services/AxiosOrderService";
import AxiosPlanningEntryService from "@/services/AxiosPlanningEntryService";
import AxiosReportService from "@/services/AxiosReportService";
import AxiosExportService from "@/services/AxiosExportService";

const companyService = new AxiosCompanyService();
const userService = new AxiosUserService();
const billService = new AxiosBillService();
const authService = new AxiosAuthService();
const orderService = new AxiosOrderService();
const planningEntryService = new AxiosPlanningEntryService();
const reportService = new AxiosReportService();
const exportService = new AxiosExportService();

const Plugin = {
	install: function (vueInstance: typeof Vue): void {
		vueInstance.$companyService = companyService;
		vueInstance.$userService = userService;
		vueInstance.$billService = billService;
		vueInstance.$authService = authService;
		vueInstance.$orderService = orderService;
		vueInstance.$planningEntryService = planningEntryService;
		vueInstance.$reportService = reportService;
		vueInstance.$exportService = exportService;

		Object.defineProperties(vueInstance.prototype, {
			$companyService: {
				get() {
					return companyService;
				}
			},
			$userService: {
				get() {
					return userService;
				}
			},
			$billService: {
				get() {
					return billService;
				}
			},
			$authService: {
				get() {
					return authService;
				}
			},
			$orderService: {
				get() {
					return orderService;
				}
			},
			$planningEntryService: {
				get() {
					return planningEntryService;
				}
			},
			$reportService: {
				get() {
					return reportService;
				}
			},
			$exportService: {
				get() {
					return exportService;
				}
			},
		});
	}
} as PluginObject<any>;


Vue.use(Plugin.install)
export default Plugin;
